import svcEntruempelung from "@/assets/schober/svc-entruempelung.webp";
import svcMessi from "@/assets/schober/svc-messi.webp";
import svcUmzug from "@/assets/schober/svc-umzug.webp";
import svcTransport from "@/assets/schober/svc-transport.webp";
import svcWohnungsaufloesung from "@/assets/schober/svc-wohnungsaufloesung.webp";
import svcFirmenumzug from "@/assets/schober/svc-firmenumzug.webp";
import svcBueroumzug from "@/assets/schober/svc-bueroumzug.webp";

export type LocalService = {
  slug: string;
  title: string; // "Entrümpelung"
  titleLong: string; // "Entrümpelung & Haushaltsauflösung"
  noun: string; // "Entrümpelung" (für Sätze)
  verb: string; // "entrümpeln"
  image: string;
  shortDescription: string;
  intro: string;
  bullets: string[];
  process: { title: string; text: string }[];
};

export const localServices: LocalService[] = [
  {
    slug: "entruempelung",
    title: "Entrümpelung",
    titleLong: "Entrümpelung & Abtransport von Sperrgut",
    noun: "Entrümpelung",
    verb: "entrümpeln",
    image: svcEntruempelung,
    shortDescription:
      "Professionelle Entrümpelung von Wohnungen, Häusern, Kellern, Dachböden und Garagen – schnell, sauber, transparent kalkuliert.",
    intro:
      "Sie benötigen eine zuverlässige Entrümpelung? Schober Transportservice räumt Wohnungen, Einfamilienhäuser, Keller, Dachböden, Garagen und Lagerflächen besenrein. Möbel, Hausrat, Elektrogeräte und Sperrgut transportieren wir ab. Die weitere Behandlung erfolgt über befugte Partnerbetriebe.",
    bullets: [
      "Kostenlose, unverbindliche Besichtigung vor Ort",
      "verbindliches Angebot – keine versteckten Kosten",
      "Besenreine Übergabe inklusive",
      "Räumung und Abtransport aus einer Hand",
      "Faire Preisgestaltung bei gut erhaltenem Inventar",
      "Termin meist innerhalb von 48 Stunden",
    ],
    process: [
      { title: "Besichtigung", text: "Unverbindlicher Vor-Ort-Termin zur Volumen- und Aufwandsschätzung." },
      { title: "Fixangebot", text: "Sie erhalten innerhalb von 24 Stunden ein schriftliches Angebot." },
      { title: "Räumung", text: "Unser Team räumt strukturiert, schützt Böden und sortiert brauchbare Stücke aus." },
      { title: "Abtransport & Übergabe", text: "Abtransport des Räumguts, besenreine Übergabe – auf Wunsch mit Reinigung." },
    ],
  },
  {
    slug: "messi-wohnung",
    title: "Messi-Wohnung Räumung",
    titleLong: "Räumung von Messie-Wohnungen",
    noun: "Messie-Räumung",
    verb: "räumen",
    image: svcMessi,
    shortDescription:
      "Diskrete, professionelle Räumung von Messie-Wohnungen und stark verwahrlosten Objekten – mit Schutzausrüstung und Empathie.",
    intro:
      "Die Räumung einer Messie-Wohnung erfordert Erfahrung, Diskretion und das richtige Equipment. Schober Transportservice räumt verwahrloste und verwahrloste Objekte mit professioneller Schutzausrüstung (PSA), inklusive Schädlingsbekämpfungs-Koordination und Desinfektion. Wir arbeiten neutral, unauffällig und ohne Werbung am Fahrzeug – auf Wunsch absolut anonym.",
    bullets: [
      "Diskrete Anfahrt – auf Wunsch ohne Firmenwerbung",
      "Vollschutzausrüstung & Atemschutz nach ÖNORM",
      "Koordination Kammerjäger & Desinfektion",
      "Sortierung & Sicherung persönlicher Dokumente",
      "Abtransport auch heikler Räumgüter",
      "Diskretion gegenüber Nachbarn & Hausverwaltung",
    ],
    process: [
      { title: "Vertrauliche Erstberatung", text: "Telefonisch oder vor Ort – streng diskret und ohne Vorverurteilung." },
      { title: "Schutz & Sicherung", text: "Aufbau Schleuse, persönliche Schutzausrüstung, Schutz Stiegenhaus." },
      { title: "Räumung & Sichtung", text: "Strukturierte Räumung, Sicherung von Dokumenten, Schmuck und Erinnerungsstücken." },
      { title: "Reinigung & Desinfektion", text: "Grundreinigung, Geruchsneutralisation, ggf. Desinfektion – übergabefertig." },
    ],
  },
  {
    slug: "umzug",
    title: "Umzug",
    titleLong: "Privater Umzug & Übersiedlung",
    noun: "Umzug",
    verb: "übersiedeln",
    image: svcUmzug,
    shortDescription:
      "Stressfreier Privatumzug: Verpackung, Transport, Aufbau – alles aus einer Hand mit Angebot.",
    intro:
      "Ihr Umzug ist bei Schober Transportservice in besten Händen. Wir übernehmen die komplette Übersiedlung – von der professionellen Verpackung mit Umzugskartons und Polstermaterial über sicheren Transport bis zum Möbelaufbau in der neuen Wohnung. Möbellift, Halteverbotszone und Klaviertransport organisieren wir mit.",
    bullets: [
      "Komplettservice von A bis Z – ein Ansprechpartner",
      "Angebot ohne versteckte Kosten",
      "Versicherter Transport bis 25.000 € inklusive",
      "Möbellift, Halteverbotszone & Klaviertransport auf Wunsch",
      "Möbeldemontage und -montage durch Profis",
      "Saubere Decken & Polster zum Schutz der Möbel",
    ],
    process: [
      { title: "Beratung & Besichtigung", text: "Wir erfassen Umzugsvolumen, Gegebenheiten und Sonderwünsche." },
      { title: "Planung & Angebot", text: "Sie erhalten ein detailliertes, schriftliches Angebot." },
      { title: "Verpackung & Transport", text: "Professionelle Verpackung, gesicherte Verladung, sicherer Transport." },
      { title: "Aufbau & Übergabe", text: "Möbelaufbau am neuen Standort, Abtransport des Verpackungsmaterials inklusive." },
    ],
  },
  {
    slug: "transport",
    title: "Transport",
    titleLong: "Transporte aller Art",
    noun: "Transport",
    verb: "transportieren",
    image: svcTransport,
    shortDescription:
      "Schnelle und sichere Transporte für Möbel, Einzelstücke, Sperrgut und Kleintransporte – auch kurzfristig.",
    intro:
      "Egal ob Einzelstück, Möbel, Sperrgut oder kompletter Hausstand – Schober Transportservice transportiert sicher, pünktlich und versichert. Unsere Transporter mit Hebebühne und Sackkarre meistern auch Stiegenhäuser und enge Zufahrten. Kurzfristige Termine sind in der Regel möglich.",
    bullets: [
      "Pünktliche Lieferung – auch Same-Day möglich",
      "Versicherter Transport bis 25.000 €",
      "Spezialequipment: Hebebühne, Klaviertrolley, Sackkarre",
      "Einzeltransport, Beistellung oder Komplettladung",
      "Faire, transparente Stunden- oder Angebot",
      "Auch IKEA-Abholungen und Online-Käufe",
    ],
    process: [
      { title: "Anfrage", text: "Senden Sie uns Strecke, Volumen und Wunschtermin – telefonisch oder per Formular." },
      { title: "Angebot", text: "Innerhalb von 60 Minuten erhalten Sie ein verbindliches Angebot." },
      { title: "Abholung", text: "Pünktliche, gesicherte Abholung mit professionellem Equipment." },
      { title: "Zustellung", text: "Sichere Zustellung, auf Wunsch mit Tragehilfe in die Wohnung." },
    ],
  },
  {
    slug: "wohnungsaufloesung",
    title: "Wohnungsauflösung",
    titleLong: "Wohnungsauflösung & Haushaltsauflösung",
    noun: "Wohnungsauflösung",
    verb: "auflösen",
    image: svcWohnungsaufloesung,
    shortDescription:
      "Komplette Wohnungs- und Haushaltsauflösung zum Angebot, besenrein und mit Übergabe an die Hausverwaltung.",
    intro:
      "Eine Wohnungsauflösung – etwa im Trauerfall, bei Umzug ins Pflegeheim oder Auslandsumzug – ist emotional belastend. Wir nehmen Ihnen diese Last ab: Schober Transportservice räumt komplette Haushalte besenrein, kalkuliert bei gut erhaltenem Inventar fair, sichert persönliche Dokumente und übergibt das Objekt schlüsselfertig an Hausverwaltung oder Eigentümer.",
    bullets: [
      "Empathische, diskrete Abwicklung im Trauerfall",
      "Faire Preisgestaltung bei gut erhaltenem Inventar",
      "Sicherung persönlicher Dokumente und Erinnerungsstücke",
      "Schlüsselübergabe an Hausverwaltung möglich",
      "Endreinigung und Malerarbeiten auf Wunsch",
      "Bundesweite Abwicklung – auch ohne Ihre Anwesenheit",
    ],
    process: [
      { title: "Erstgespräch", text: "Einfühlsame Erstberatung – telefonisch, online oder vor Ort." },
      { title: "Sichtung & Bewertung", text: "Wir bewerten Inventar, Wertgegenstände und Räumumfang." },
      { title: "Auflösung", text: "Strukturierte Auflösung, Sicherung Dokumente, faire Preisgestaltung bei gut erhaltenem Inventar." },
      { title: "Übergabe", text: "Besenreine Übergabe, auf Wunsch Schlüsselübergabe an Hausverwaltung." },
    ],
  },
  {
    slug: "firmenumzug",
    title: "Firmenumzug",
    titleLong: "Firmenumzug & Betriebsübersiedlung",
    noun: "Firmenumzug",
    verb: "übersiedeln",
    image: svcFirmenumzug,
    shortDescription:
      "Betriebsumzug mit minimaler Ausfallzeit: Werkstätten, Lager, Produktion und Verkaufsflächen – Wochenend-Umzug möglich.",
    intro:
      "Ein Firmenumzug muss reibungslos und ohne lange Ausfallzeiten ablaufen. Schober Transportservice übersiedelt Betriebe aller Branchen – von der Werkstatt über Lager bis zur Verkaufsfläche. Wir arbeiten auch am Wochenende oder nachts, demontieren und montieren Maschinen sowie Regalsysteme und kümmern uns um IT-fachgerechten Transport.",
    bullets: [
      "Wochenend- und Nachtumzüge zur Minimierung von Ausfallzeiten",
      "Projektplanung mit fixem Zeitplan",
      "Demontage und Montage von Regalsystemen und Maschinen",
      "Spezialverpackung für IT und sensible Geräte",
      "Aktenumzug mit Datenschutz nach DSGVO",
      "Abtransport von Altequipment & Akten inklusive",
    ],
    process: [
      { title: "Projektanalyse", text: "Begehung, Bestandsaufnahme, Zeitplan – abgestimmt auf Ihren Betriebsablauf." },
      { title: "Umzugsplan", text: "Detaillierter Projektplan mit Verantwortlichkeiten und Meilensteinen." },
      { title: "Durchführung", text: "Verpackung, Demontage, Transport, Montage – auch außerhalb der Geschäftszeiten." },
      { title: "Inbetriebnahme", text: "Aufstellung nach Plan, IT-Anschluss, Test, Übergabe – einsatzbereit am Montag." },
    ],
  },
  {
    slug: "bueroumzug",
    title: "Büroumzug",
    titleLong: "Büroumzug & Office-Move",
    noun: "Büroumzug",
    verb: "übersiedeln",
    image: svcBueroumzug,
    shortDescription:
      "Büroumzug mit IT-Service, Akten-Transport (DSGVO-konform), Möbelmontage und neuer Arbeitsplatz-Aufstellung.",
    intro:
      "Ihr Büroumzug ist bei Schober Transportservice ein strukturiertes Projekt. Wir übersiedeln Arbeitsplätze, Konferenzräume und Empfangsbereiche – inklusive Demontage und Montage von Schreibtischen, Container und Rollcontainern. Akten und Datenträger transportieren wir DSGVO-konform in versiegelten Boxen.",
    bullets: [
      "Etiketten-System für jeden Arbeitsplatz",
      "DSGVO-konformer Aktentransport in versiegelten Boxen",
      "IT-Equipment: Bildschirme, PCs, Server – fachgerecht",
      "Möbeldemontage und Wiederaufbau am Zielort",
      "Wochenend-Umzug, damit Montag der Betrieb läuft",
      "Abtransport von Altmöbeln und Akten auf Wunsch",
    ],
    process: [
      { title: "Inventur", text: "Erfassung aller Arbeitsplätze, Möbel und IT-Komponenten." },
      { title: "Etikettierung", text: "Jeder Karton und jedes Möbelstück erhält einen Zielraum-Code." },
      { title: "Umzug", text: "Demontage, Transport, Montage – Arbeitsplätze stehen wie vorher." },
      { title: "Übergabe", text: "Endkontrolle, IT-Test, Schlüsselübergabe – startklar am nächsten Werktag." },
    ],
  },
];

export const localServiceBySlug = Object.fromEntries(
  localServices.map((s) => [s.slug, s]),
) as Record<string, LocalService>;
